import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9641a774"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-label" }
const _hoisted_2 = { class: "list-value" }

import { withDefaults, watch, defineAsyncComponent, ref } from 'vue';
interface IProps {
  items: any[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MoleculeList',
  props: {
    items: null
  },
  emits: ['handleToggle'],
  setup(__props: any, { emit }) {

const props = __props as { items: any[] };



function handleToggle() {
  emit('handleToggle')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("ul", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, idx) => {
      return (_openBlock(), _createElementBlock("li", {
        key: idx+'it',
        class: "py-5 d-flex justify-space-between"
      }, [
        _createElementVNode("p", _hoisted_1, _toDisplayString(item.label), 1),
        _createElementVNode("p", _hoisted_2, _toDisplayString(item.value), 1)
      ]))
    }), 128))
  ]))
}
}

})